import {makeVar} from '@apollo/client';

export const accountVar = makeVar(null);